<template>
  <div class="info-list">
    <div class="title1">
      <h2><img src="@/assets/img/common/icon-nav3_blue.svg" alt="" width="22" height="22">お知らせ</h2>
      <a class="link-arrow" @click="goNoticeList()">すべてのお知らせ</a>
    </div>
    <ul class="news-list" :class="{ 'mt-20' : !isDiagAvailablePlan }">
      <li v-for="notice in noticeList" :key="notice.noticeId">
        <a @click="goDetail(notice.noticeId)">
          <span v-if="notice.file" class="file"><img src="@/assets/img/common/icon-attch_on.svg" alt=""></span>
          <span v-else class="file"><img src="@/assets/img/common/icon-attch_off.svg" alt=""></span>
          <span class="date">{{ $dayjs(notice.fromDt).format("YYYY年MM月DD日") }}</span>
          <span class="info-catlabel">{{ noticeTypeName(notice)}}</span>
          <span class="text">
            {{ notice.title }}
            <span v-if="notice.isNew" class="info-newlabel">NEW</span>
          </span>
        </a>
      </li>
    </ul>
    <NoticeDetailModal
      v-show="isShowNoticeDetail"
      ref="noticeDetail"
      @close-notice-detail="closeNoticeDetail()"
    ></NoticeDetailModal>
  </div>
</template>

<script>
import NoticeDetailModal from '@/components/pages/portal/notice/NoticeDetailModal.vue';
import constant from '@/const';

export default {
  components: {
    NoticeDetailModal,
  },
  data() {
    return {
      noticeList: [
        {
          file: {}
        }
      ],
      isShowNoticeDetail: false,
      noticeId: null,
      selectNoticeTypeList: constant.NOTICE_TYPE,
    }
  },
  computed: {
    noticeTypeName : () => (notice) => {
      let noticeType = constant.NOTICE_TYPE.find(function(element) {
        return element.value === notice.noticeType;
      });
      if (!noticeType) return '';
      return noticeType.label;
    },
  },
  props: {
    isDiagAvailablePlan: {}
  },
  created: function() {
    this.getLatestNoticeList();
  },
  methods: {
    async getLatestNoticeList() {
      let res = await this.$axios.post('/ld/api/notice/getLatestNoticeList', {
        page: 1,
        inPeriod: true,
        forOffice: false,
        deleteFlg: false,
      });
      if (res) {
        this.noticeList = res.data.noticeList.data;
      }
    },
    showNoticeDetail(noticeId) {
      this.noticeId = noticeId;
      this.$refs.noticeDetail.getNotice(noticeId);
      this.isShowNoticeDetail = true;
    },
    closeNoticeDetail() {
      this.isShowNoticeDetail = false;
      this.noticeId = null;
    },
    goNoticeList() {
      this.$router.push({ name: 'notice-list' });
    },
    goDetail(noticeId) {
      this.$store.dispatch('portal/setNoticeId', noticeId);
      this.$router.push({ name: 'notice-detail', query: { noticeId: noticeId } });
    },
  }
}
</script>
